module.exports = __webpack_public_path__ + "img/Projects&Timesheets.49599f32.svg";